import { formatData, sortByDateReverse } from "./utils";

export function fetchSpendings(){
    return async function (dispatch){
        dispatch({ type: "FETCH_SPENDINGS_START", payload: "" })
        try {

            const req = await fetch('/spendings/get/list', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('fetchSpendings res : ', res);

            if (!res.error) {
                let formated_spendings_list = formatData(sortByDateReverse(res.data, "timeAction"), "timeAction")
                dispatch({
                    type: "GET_SPENDINGS",
                    payload: formated_spendings_list
                })
    
                // dispatch({
                //     type: "GET_ALL_CLIENTS_SPENDINGS",
                //     payload: spendings_list
                // })
                dispatch({ type: "FETCH_SPENDINGS_FULFILLED", payload: "" }) 
            } else {
                dispatch({ type: "FETCH_SPENDINGS_ERROR", payload: res.error })
            }

        } catch (error) {
            console.log("[ERROR] get spendings list : ", error);
            dispatch({ type: "FETCH_SPENDINGS_ERROR", payload: error })
        }
         
    }
}
export function updateSpending(data){
    return async function (dispatch){
        dispatch({ type: "UPDATE_SPENDING_START", payload: "" })
        try {

            const req = await fetch('/spendings/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            });
            let res = await req.json();
            console.log('updateSpending res : ', res);

            if (!res.error) {
                
                dispatch({
                    type: "UPDATE_SPENDING",
                    payload: data
                })
    
               
                dispatch({ type: "UPDATE_SPENDING_FULFILLED", payload: "" }) 
            } else {
                dispatch({ type: "UPDATE_SPENDING_ERROR", payload: res.error })
            }

        } catch (error) {
            console.log("[ERROR] get spendings list : ", error);
            dispatch({ type: "UPDATE_SPENDING_ERROR", payload: error })
        }
         
    }
}
